import React, { useCallback, useRef, useState } from "react";
import { useTranslation, Trans } from 'react-i18next';
import { UploadFileOutlined, CloseOutlined } from "@mui/icons-material";
import { useDropzone } from "react-dropzone";
import colors from "../../../scss/colors";
import MainButton from "../buttons/MainButton";
import { buttonVariants } from "../buttons/types";


export default function CVUploader({
    extensions = {
        'application/pdf': ['.pdf'],
        'application/msword': ['.doc', '.docx'],
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
    },
    onFilesSelected = () => { },
    onUpload = () => { },
}) {
    const [files, setFiles] = useState([]);
    const { t } = useTranslation();
    const inputRef = useRef(null);

    const onDrop = useCallback((acceptedFiles) => {
        setFiles(
            acceptedFiles.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) }))
        );
        onFilesSelected(acceptedFiles);
        onUpload(acceptedFiles);
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: { ...extensions },
    });

    return (
        <div className="flex flex-col w-full">
            <div className="flex md:hidden my-5 w-full justify-center">
                <input {...getInputProps()} ref={inputRef} style={{ display: 'none' }} />
                <MainButton
                    variant={buttonVariants.SECONDARY}
                    rounded
                    outlined
                    size="small"
                    action={() => inputRef.current?.click()}
                    sx={{
                        gap: '10px',
                    }}
                >
                    <UploadFileOutlined />
                    <span className="text-secondary">Upload CV</span>
                    <span className="text-gray-500">{`(PDF, DOC, DOCX)`}</span>
                </MainButton>
            </div>
            <div
                {...getRootProps()}
                className={`hidden md:flex flex-row items-start gap-2 justify-center p-5 border-2 border-dashed cursor-pointer transition-colors 
                    ${isDragActive ? 'border-navy-blue bg-sky-50' : 'border-secondary bg-red'}`}
            >
                <input {...getInputProps()} />
                <UploadFileOutlined sx={{ fontSize: 34, color: colors.LIGHT_BLUE, pt: 0.5 }} />
                <div>
                    {files.length > 0 ? (
                        <p className="font-medium pb-2">
                            {files.map((file, key) => (
                                <span key={key} className="text-navy-blue">{file?.name}</span>
                            ))}
                        </p>
                    ) : (
                        <p className="font-medium pb-2">
                            <Trans i18nKey="dashboard.profile.uploadCV" className="font-medium" components={{
                                1: <span className="text-secondary">Browse</span>,
                                2: <span className="text-gray-500">{`PDF, DOC, DOCX`}</span>
                            }} />
                        </p>
                    )}
                    <span className="text-sm text-gray-500">{t('dashboard.profile.cvExtractInfo')}</span>
                </div>
                {files.length > 0 && (
                    <div>
                        <CloseOutlined
                            sx={{ fontSize: 24, color: colors.GRAY, cursor: 'pointer' }}
                            onClick={() => {
                                setFiles([]);
                                onFilesSelected([]);
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}